import React, { useState, useRef, useEffect } from 'react';
import './TypingTeacher.css';

let asciiArray = [];  // tablica zanków ASCII, z której będa losowane znaki do tekstu

// komponent funkcyjny CharSpan (opakowuje literę w tag <span>)
// forwardRef przekazuje referencję do komponentu, dzięki czemu można np. zmienić podkreślenie litery
const CharSpan = React.forwardRef(({ value, className }, ref) => {
    return (
        <span className={className} ref={ref}>
            {value}
        </span>
    );
});

// komponent funkcyjny wyświetlający stan capslocka i numlocka
function NumCapsStatus({specKeyInfo, value}){
    return(
        <div style={{ color:'blue'}}>
            {specKeyInfo}: {value ? "ON (depends on the initial state)" : "OFF (depends on the initial state)"}
        </div>    
        )
}

// komponent funkcyjny wyświetlajacy podsumowanie
function Result({info}){
    return(
        <div>
            <h3 style={{ color:'blue'}}>
                {info}
            </h3>
        </div>
    )
}

// komponent funkcyjny zarządzający tekstami
const Teksts = ({ tekstToWrite, divRef}) => {
    const spansRef = useRef([]);            // tablica referencji do elementów <span>, w których siedzą litery
    const [userInputText, setUserInputText] = useState([]);  // tablica na tekst wklepany przez użytkownika
    const [charIndex, setCharIndex] = useState(0);  // index litery w tablicy
    const [good, setGood] = useState(0);    // ilość poprawnych znaków
    
    let[capslockFlag, setCapslockFlag] = useState(false); // falga właczenia CapsLocka
    let[numlockFlag, setNumlockFlag] = useState(false);   // flaga właczenia NumLocka
    let[specKeyName, setSpecKeyName] = useState("");      // nazwa naciśniętego klawisza specjalnego
    const[resultInfo, setResultInfo] = useState("");      // osiągnięty rezultat

   
    // wyswietlenie stanu capslock i numlock
    function isCapslockNumlockPressed(key){
        if(key === "CapsLock"){
            setCapslockFlag(prevFlag => !prevFlag); // toggle state
        }
        if(key === "NumLock"){
            setNumlockFlag(prevFlag => !prevFlag); // toggle state
        }
    }

    // komponent klawisza specjalnego
    function SpecKey({specKeyInfo, value}){
        return(
            <div style={{ color:'blue'}}>
                {specKeyInfo} {value}
            </div>    
            )
    }
    
    // podsumowanie - % poprawnego tekstu
    function summary(){
        //console.log("good/tekstToWrite.length " + good + " " + tekstToWrite.length)
        let wynik = 0;
        wynik = (good/tekstToWrite.length)*100;
        wynik = wynik.toFixed(2);    // zaokrąglenie do 2 znaków po przecinku
        setResultInfo(wynik + "%");
    }
    
    // sparawdzenie czy nacisniety klawisz jest klawiszem funkcyjnym (specjalnym)
    function isNotSpecialKey(key){
        let specKeys = ["Shift", "Alt", "Meta", "Tab", "Control", "CapsLock","AltGraph",
                        "F1","F2","F3","F4","F5","F6","F7","F8","F9","F10","F11","F12",
                        "ArrowLeft","ArrowDown","ArrowRight","ArrowUp","NumLock","ContextMenu",
                        "Insert","Delete","Enter","PageDown","PageUp","Home","End","Clear","Backspace",
                        "ScrollLock","Pause","Escape"]
        let check = true;
        for(let i = 0; i < specKeys.length; i++){
            if(key === specKeys[i]){
                setSpecKeyName("naciśnięto klawisz specjalny: " + key); 
                check = false;
            }
        }
        return check
    }

    // UWAGA! NIERAZ WYWALA BŁEDY PRZY WŁĄCZENIU KOMPONENTU TYPING TEACHER
    // gdy zmieni się tekstToWrite czyścimy podkreślenia (bez tego zostawało, gdy przerwalismy lekcję)
    
    useEffect(() => {
        setTimeout(() => { 
            for(let i = 1; i < tekstToWrite.length; i++){
                if (spansRef.current[i]) {
                    spansRef.current[i].current.style.textDecoration = "none";
                }
            }
        }, 10); // Opóźnienie minimalne (0 ms)
        
    }, [tekstToWrite])  // uruchamia sie, gdy zmieni się tekstToWrite
    
    // useEffect to hook w React, który pozwala na wykonywanie efektów ubocznych w komponentach funkcyjnych np.
    // manualne manipulacje z DOM-em.
    // wywoływana przy każdej zmianie stanu tekstToWrite
    useEffect(() => {
         // reset osiągnietego wyniku
        setResultInfo("");

        
        // Array(tekstToWrite.length) - Tworzy nowy array o długości równej długości tekstToWrite.
        // .fill(null) - Wypełnia utworzony array null-ami.
        // .map(() => React.createRef()) - Stwierdza, że każdy element w tablicy ma być nowym obiektem React.createRef. 
        // Ten obiekt będzie miał metodę current, która będzie wskazywała na element DOM, w którym ten ref zostanie umiejscowiony.
        // Dzięki temu będzie można zmienić styl elementu DOM wskazanego przez te refy
        spansRef.current = Array(tekstToWrite.length)
            .fill(null)
            .map(() => React.createRef());

        // opóżnienie podkreślenie pierwszego znaku 
        // To daje czas przeglądarce na zrenderowanie elementów DOM i ustawienie refów.
        setTimeout(() => { 
            // Set underline on the first character if it exists
            if (spansRef.current.length > 0 && spansRef.current[0].current) {
                spansRef.current[0].current.style.textDecoration = "underline";
            }
        }, 0); // Opóźnienie minimalne (0 ms)
        // reset
        setUserInputText([]);
        setCharIndex(0);
        setGood(0);
    }, [tekstToWrite]);  // Efekt będzie uruchamiany, gdy zmieni się `tekstToWrite`.

    // obsługa naciśnięcia klawisza
    const handleKeyDown = (event) => {
        const key = event.key;

        // po wciśnięciu litery l (el) reagował select - wstawiona blokada
        if (key === 'l' || key === 'L' || key === ' ' || key === 'ArrowDown' || key === 'ArrowUp' || key === 'ArrowLeft' || key === 'ArrowRight'
            || key === 'PageDown' || key === 'PageUp' || key === 'Home' || key === 'End'
        ) { 
            event.preventDefault(); // Zablokuj domyślne zachowanie
            // event.stopPropagation(); // (Opcjonalnie) Zatrzymuje propagację zdarzenia
        }

        isCapslockNumlockPressed(key);   // wyświetlenie stanu klawiszy NumLock i CapsLock

        // poszczególne litery wklepanego przez użytkownika tekstu opakowujemy w element <span>
        // do każdego elementu <span> wstawiamy referencję w celu podkreślenia litery 
        if (charIndex < tekstToWrite.length && isNotSpecialKey(key)) {
            const newInputText = [
                ...userInputText,
                <CharSpan
                    key={charIndex}
                    value={key}
                    className={key === tekstToWrite[charIndex] ? "typing-teacher-green" : "typing-teacher-red"}  // poprawny znak zielony
                    ref={spansRef.current[charIndex]}
                />
            ];

            // reset wyświetlenia klawisza specjalnego
            setSpecKeyName("");

            // zmiana stanu tablicy przechowującej wklepany tekst
            setUserInputText(newInputText);
            
            // zmiana podkreślenia kolejnej litery do wklepania
            if (spansRef.current[charIndex]) {
                spansRef.current[charIndex].current.style.textDecoration = "none";
            }
            if (spansRef.current[charIndex + 1]) {
                spansRef.current[charIndex + 1].current.style.textDecoration = "underline";
            }

            // inkrementacja poprawnie wklepanych znaków
            if (key === tekstToWrite[charIndex]) {
                setGood(prev => prev + 1);
            }

            // inkrementacja indeksu litery do wpisania
            setCharIndex(prev => prev + 1);

            //if (charIndex >= tekstToWrite){
            //    setCharIndex(0);  
            //}
        }

    };

    // obsługa naciśnietego klawisza (nasłuchiwanie) oraz podsumowania
    useEffect(() => {

        const divElement = divRef.current;

        
        // po wyczerpaniu liter w słowie uruchamiamy podsumowanie
        if (charIndex >= tekstToWrite.length){
            summary()   // podsumowanie
        }else{
            setResultInfo("");  // reset napisu
        }   

        divElement.addEventListener('keydown', handleKeyDown);
        //document.addEventListener('keydown', handleKeyDown);
        // Funkcja zwracana z useEffect jest funkcją czyszczącą, która jest wywoływana przed kolejnym uruchomieniem efektu 
        // (jeżeli zachodzi potrzeba) oraz przy odmontowywaniu komponentu.
        return () => {
            divElement.removeEventListener('keydown', handleKeyDown);
            //document.removeEventListener('keydown', handleKeyDown);
        };
    }, [userInputText, charIndex, tekstToWrite]);  // zależności
    // useEffect będzie wywoływał się ponownie za każdym razem, gdy którakolwiek z tych wartości zostanie zaktualizowana. 
    // To oznacza, że jeśli użytkownik wprowadzi nowy tekst (zmiana userInputText), 
    // zmieni wartość charIndex lub zmieni tekstToWrite, efekt się uruchomi ponownie, 
    // co daje możliwość dynamicznego dostosowywania logiki komponentu.

    return (
        <div>
            <div id="typing-teacher-tekst-to-write">
                {tekstToWrite.split('').map((char, index) => (
                    <span key={index} ref={spansRef.current[index]}>{char}</span>
                ))}
            </div>
            <div id="typing-teacher-user-input-text">
                {userInputText}
            </div>
            <div id="typing-teacher-caps-num-spec">
                <NumCapsStatus specKeyInfo="CapsLock "  value = {capslockFlag} />
                <NumCapsStatus specKeyInfo="NumLock "  value = {numlockFlag} />
                <SpecKey specKeyInfo=""  value = {specKeyName} />
            </div>
            <p style={{ color:'blue'}}>Ilość poprawnych znaków: {good}</p>
            <Result info={resultInfo} />
        </div>
    );
};

// głowny komponent funkcyjny   
export default function TypingTeacher() {
    const [index, setIndex] = useState(0);    // index w tablicy tekstów do przepisania
    const [teksty, setTeksty] = useState(["Litwo, Ojczyzno moja! ty jesteś jak zdrowie; Ile cię trzeba cenić, ten tylko się dowie, Kto cię stracił. Dziś piękność twą w całej ozdobie Widzę i opisuję, bo tęsknię po tobie.", 
                                            "Abecadło z pieca spadło, O ziemię się hukło, Rozsypało się po kątach, Strasznie się potłukło: I -- zgubiło kropeczkę, H -- złamało kładeczkę "]);  // teksty do przepisania

    const divTypingTeacherRef = useRef(null);   // referencja do nasłuchiwania klawisza tylko na divie typing teachera
                                                // gdy damy na document - wpisuje litery z innych właczonych komponentów
    /*
    * 32:       space
    * 48- 57    cyfry
    * 65 - 90   duże litery
    * 97 - 122  małe litery
    *
    */
    // dodajemy znaki do tablicy asciiArray, z której będziemy losować znaki do zadanego randomowego tekstu
    // (bez spacji - ją dodamy do tekstu później)
    function handleAsciiCharArray(){
        // dodajemy cyfry
        for(let i = 48; i<58; i++){
            asciiArray.push(String.fromCharCode(i))
        }
        // dodajemy duże litery
        for(let i = 65; i<91; i++){
            asciiArray.push(String.fromCharCode(i))
        }
        // dodajemy małe litery
        for(let i = 97; i<123; i++){
            asciiArray.push(String.fromCharCode(i))
        }
    }       


    // wstawiamy randomowy tekst  
    // asciiArray ma 62 znaki
    function insertRandomTekst(){
        let randomText = "";            // string bez spacji
        let randomTextWithSpace = "";   // nowy string ze spacjami
        let textLength = 100;           // dłaugośc tekstu
        let maxCharIndex = 63;          // długość tablicy asciiArray ze znakami (+1 do losowania)
        let maxSpaceIndex = 5;  // max co 15 znaków spacja
        let minSpaceIndex = 0
        let spaceIndex = Math.floor(Math.random() * maxSpaceIndex) + 1; // 1 - 15 losowany indeks spacji, wartość początkowa
        let charIndex = 0;  // losowany index znaku
        
        // tworzymy tekst bez spacji
        for(let i = 0; i<textLength; i++){
            // znaki
            charIndex = Math.floor(Math.random() * maxCharIndex); // 0 - 62
            randomText += asciiArray[charIndex];    
        }
        // dodajemy spacje - tworzymy nowy tekst
        for(let i = 0; i<textLength; i++){
            // spacje
            if (i == spaceIndex){
                //console.log(" randomText[i]: " +  randomText[i])
                //randomText[i] = " ";
                randomTextWithSpace += " ";      // dodajemy spację
                minSpaceIndex = spaceIndex + 4;
                maxSpaceIndex += 8; 
                spaceIndex = Math.floor(Math.random() * (maxSpaceIndex - minSpaceIndex)) + minSpaceIndex;  
                //console.log("i:" + i + "," + "spaceIndex:  " + spaceIndex + " randomText[i]: " +  randomText[i])
            }else{
                randomTextWithSpace += randomText[i];   // dodajemy literę, która jest w tekście
            }
        }
        let tmpTeksty = teksty.slice();
        tmpTeksty.push(randomTextWithSpace);   // wrzucamy tekst ze spacjami do tekstów
        setTeksty(tmpTeksty)
        //teksty.push(randomTextWithSpace);   // wrzucamy tekst ze spacjami do tekstów
    }

    // TODO jednokrotnie (jest jednokrotnie)
    if(index === 0){
        // dodajemy znaki do tablicy asciiArray, z której będziemy losować znaki do tekstu
        handleAsciiCharArray();
    }

    // obsługa zmiany tekstu w selekcie
    const handleOnChange = (event) => {
        const selectedIndex = event.target.value;
        setIndex(selectedIndex);
        // usuwa randomowy tekst jeśli jest wstawiony
        if (teksty.length >= 3){ 
            let tmpTeksty = teksty.slice(0,2);
            setTeksty(tmpTeksty)
        }
        // jeśli wybrano randomowy tekst, wstawiamy go do tablicy teksty
        //if (teksty.length === 2){   
        if (selectedIndex === "2"){ 
            insertRandomTekst()
        }
    };

    return (
        <div 
            ref={divTypingTeacherRef}  // referencja komponentu Typing Teacher (do nasłuchiwania naciśniecia litery tylko w tym komponencie)
            tabIndex={0} // Dodaj tabindex, aby element mógł być fokusowany
        >
            <h1>Typing Teacher</h1>
            <Teksts tekstToWrite={teksty[index] || ""} divRef={divTypingTeacherRef}/>
            <select onChange={handleOnChange}>
                <option value="0">Lesson 1</option>
                <option value="1">Lesson 2</option>
                <option value="2">random</option>
            </select>
            <span> Select lesson</span>
            
        </div>
    );
}